module.exports = "/_next/static/images/settings-d4d0a7e83af76a4872695378304dd507.svg";